import React, { useState } from "react";
import { TrendingUp, BarChart3, Target } from "lucide-react";
import "./AdHero.css";
import { Link } from "react-router-dom";

const questions = [
  {
    id: 1,
    level: "Step 1: Current Ad Spend",
    question: "What’s your current monthly ad spend?",
    options: [
      { text: "Under $5k", score: 10 },
      { text: "$5k–$20k", score: 20 },
      { text: "$20k–$100k", score: 40 },
      { text: "$100k+", score: 60 },
    ],
  },
  {
    id: 2,
    level: "Step 2: Data Tracking",
    question: "Do you have accurate tracking set up for all channels?",
    options: [
      { text: "Yes, fully", score: 10 },
      { text: "Somewhat", score: 5 },
      { text: "Not sure", score: 0 },
      { text: "No tracking", score: 0 },
    ],
  },
  {
    id: 3,
    level: "Step 3: Strategy",
    question: "What’s your current approach to scaling?",
    options: [
      { text: "Testing different channels", score: 10 },
      { text: "Running basic ads", score: 5 },
      { text: "Structured campaigns (need better ROAS)", score: 20 },
      { text: "Full-funnel approach", score: 30 },
    ],
  },
  {
    id: 4,
    level: "Step 4: Customer Retention",
    question: "Do you have a system to bring back past customers?",
    options: [
      { text: "Yes, via email/SMS + ads", score: 15 },
      { text: "Only email/SMS", score: 5 },
      { text: "None", score: 0 },
    ],
  },
  {
    id: 5,
    level: "Step 5: Revenue Goals",
    question: "What’s your target monthly revenue (next 6 months)?",
    options: [
      { text: "Under $50k", score: 10 },
      { text: "$50k–$250k", score: 20 },
      { text: "$250k–$1M", score: 40 },
      { text: "$1M+", score: 60 },
    ],
  },
];

const QuizHero = () => {
  const [current, setCurrent] = useState(0);
  const [score, setScore] = useState(0);
  const [finished, setFinished] = useState(false);

  const handleAnswer = (opt) => {
    setScore((s) => s + opt.score);
    if (current < questions.length - 1) {
      setCurrent((c) => c + 1);
    } else {
      setFinished(true);
    }
  };

  return (
    <div className="game-wrapper">
      <div className="section-bg">
        <div className="orb-4"></div>
        <div className="orb-5"></div>
        <div className="floating-particles"></div>
      </div>

      <div className="container">
        {!finished ? (
          <div className="game-wrapper-inner">
            <div className="game-header">
              <div className="stats-wrapper">
                <div className="stat-item">
                  <div className="stat-label">Progress</div>
                  <div className="stat-value combo-value">
                    {current + 1} / {questions.length}
                  </div>
                </div>
                <div className="stat-item">
                  <div className="stat-label">Score</div>
                  <div className="stat-value score-value">{score}</div>
                </div>
              </div>
            </div>

            <div className="overlay-state">
              <div className="menu-content">

                <h2 className="menu-title">{questions[current].level}</h2>
                <p className="menu-description">{questions[current].question}</p>
                <div className="flex flex-col gap-3 mt-6">
                  {questions[current].options.map((opt, i) => (
                    <button
                      key={i}
                      onClick={() => handleAnswer(opt)}
                      className="cta-button"
                    >
                      {opt.text}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="overlay-state gameover-overlay">
            <div className="gameover-content">
              <TrendingUp className="gameover-trophy" />
              <h2 className="gameover-title">Your Growth Score</h2>

              <div className="final-stats">
                <div className="final-stat">
                  <span className="final-stat-label">Score:</span>
                  <span className="final-stat-value score-color">
                    {score} pts
                  </span>
                </div>
              </div>

              <p className="menu-description">
                Based on your answers, your store has significant growth
                opportunities. Let’s discuss how to unlock them.
              </p>

              <Link to="/consultation" style={{ textDecoration: "none" }}>
                <button className="cta-button">Book a Free Consultation</button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default QuizHero;
